import { UseFormMethods } from 'react-hook-form'

import { Box } from '@chakra-ui/react'

import { FormInputSelectControl } from '@/components/ui'

import { Options } from '../../types/types'
import { FormInputsIProps } from '../types/types'
import { deviceTypes } from '../utils/utils'
import { GenericDeviceForm } from './GenericDeviceForm'

interface CreateDeviceFormIProps {
  form: UseFormMethods<FormInputsIProps>
  facilityOptions: Options
  floorOptions: Options
  isOptionsLoading: boolean
  isFacilitiesLoading: boolean
  isFacilitiesError: boolean
  isIncidentTypesLoading: boolean
  incidentTypeOptions: Options
  setFacilityName: React.Dispatch<React.SetStateAction<string>>
}
export const CreateDeviceForm = ({
  form,
  isFacilitiesLoading,
  isFacilitiesError,
  isOptionsLoading,
  facilityOptions,
  floorOptions,
  isIncidentTypesLoading,
  incidentTypeOptions,
  setFacilityName,
}: CreateDeviceFormIProps) => {
  const { control, errors } = form
  return (
    <Box>
      <Box mb='3'>
        <FormInputSelectControl
          control={control}
          errorMessage={!!errors?.type && 'Select a device type'}
          id='type'
          isClearable
          isInvalid={!!errors?.type}
          label='Device Type'
          options={deviceTypes}
          placeholder='Device Type Selection'
          rules={{ required: true }}
        />
      </Box>

      <GenericDeviceForm
        facilityOptions={facilityOptions}
        floorOptions={floorOptions}
        form={form}
        incidentTypeOptions={incidentTypeOptions}
        isFacilitiesError={isFacilitiesError}
        isFacilitiesLoading={isFacilitiesLoading}
        isIncidentTypesLoading={isIncidentTypesLoading}
        isOptionsLoading={isOptionsLoading}
        setFacilityName={setFacilityName}
      />
    </Box>
  )
}
